import { EntityEditBankInfoBlock } from "features/entities/edit/EntityEditBankInfoBlock";
import { InvestorEntityContactInfoBlock } from "features/investor-entities/tabs/profile/InvestorEntityContactInfoBlock";
import { InvestorEntityExternalIdsBlock } from "features/investor-entities/tabs/profile/InvestorEntityExternalIdsBlock";
import { InvestorEntityProfileBlock } from "features/investor-entities/tabs/profile/InvestorEntityProfileBlock";
import React from "react";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const InvestorEntityTabProfile: React.FC = () => {
  const { investorEntityId } = useRequiredStringParams();
  return (
    <PageTabBody data-private={true}>
      <InvestorEntityProfileBlock investorEntityId={investorEntityId} />
      <InvestorEntityExternalIdsBlock investorEntityId={investorEntityId} />
      <InvestorEntityContactInfoBlock investorEntityId={investorEntityId} />
      <EntityEditBankInfoBlock entityId={investorEntityId} />
    </PageTabBody>
  );
};
